import * as React from 'react'
import ContentfulRichText from '../contentful-richtext/contentful-richtext.component'
import MdxRenderer from '../mdx-renderer/mdx-renderer.component'

export type WidgetContentProps = {
  contents?: GatsbyTypes.Maybe<GatsbyTypes.contentFragment>
}

const WidgetContent: React.FC<WidgetContentProps> = ({ contents }) => {
  if (!contents) return null
  return (
    <>
      {contents.richText?.raw ? <ContentfulRichText richText={contents.richText} /> : null}
      {contents.markdownText?.childMdx?.body ? <MdxRenderer mdx={contents.markdownText.childMdx} /> : null}
    </>
  )
}

export default WidgetContent
